<template>
  <div>
    <Header> One Time Ride Form </Header>
    <div class="tiled-bar-image"></div>
    <Main>
      <div class="flex justify-center gap-2">
        <RideForm
          ref="RideForm"
          v-if="defaultValues"
          :defaultValues="defaultValues"
          :gradeList="gradeList"
          v-model="formValues"
        />
      </div>
    </Main>
  </div>
</template>

<style scoped>
.tiled-bar-image {
  width: 100%;
  height: 25px;
  background-image: url("@/assets/Bar.png");
  background-repeat: repeat-x;
}
</style>

<script>
import Header from '../components/Header.vue'
import Main from '../components/Main.vue'
import RideForm from '../components/RideForm.vue'
import DropdownLists from '../components/DropdownLists.json'
import { getStudentDetail } from '../services/api'

export default {
  components: {
    Header, 
    Main, 
    RideForm,
  },
  data() {
    return {
      formValues: {},
      defaultValues: {},
      gradeList: DropdownLists.gradeList,
    }
  },
  methods: {
    async fetchStudentDetail(dbId) {
      try {
        const studentData = await getStudentDetail(dbId)
        console.log("Fetched Student Data:", studentData)
        this.defaultValues = studentData.data
      } catch (error) {
        console.error("Error fetching student details:", error)
      }
    },
  },
  mounted() {
    const dbId = this.$route.params.dbId
    if (dbId) {
      this.fetchStudentDetail(dbId)
    } else {
      console.warn("No dbId provided in route params.")
    }
  },
}
</script>
